import { apiClient } from "../../../lib";
import {
  GetSchedulesResponse,
  GetScheduleResponse,
  CreateSchedulingItemPayload,
  UpdateSchedulingItemPayload,
  UpdateMultipleSchedulingPayload,
  GetLinksResponse,
  GetLinkResponse,
  CreateLinkPayload,
  UpdateLinkPayload,
} from "../types/scheduling";

export interface OutageWindowPayload {
  outage_start_date: string | null;
  outage_end_date: string | null;
  status?: string;
}

export const schedulingApi = {
  getSchedules: async (projectId: number): Promise<GetSchedulesResponse> => {
    const response = await apiClient.get(`/projects/${projectId}/scheduling`);
    return response.data;
  },

  getSchedule: async (scheduleId: number | undefined): Promise<GetScheduleResponse> => {
    const response = await apiClient.get(`/projects/scheduling/${scheduleId}`);
    return response.data;
  },

  createSchedule: async (
    projectId: number,
    payload: CreateSchedulingItemPayload
  ): Promise<GetScheduleResponse> => {
    const response = await apiClient.post(
      `/projects/${projectId}/scheduling`,
      payload
    );
    return response.data;
  },

  updateSchedule: async (
    projectId: number,
    scheduleId: number,
    payload: Partial<UpdateSchedulingItemPayload>
  ): Promise<GetScheduleResponse> => {
    const response = await apiClient.put(
      `/projects/${projectId}/scheduling/${scheduleId}`,
      payload
    );
    return response.data;
  },

  updateMultipleSchedules: async (
    projectId: number,
    payload: UpdateMultipleSchedulingPayload
  ): Promise<{ status: boolean; message: string }> => {
    const response = await apiClient.patch(
      `/projects/${projectId}/scheduling`,
      payload.items
    );
    return response.data;
  },

  deleteSchedule: async (
    projectId: number,
    scheduleId: number
  ): Promise<{ status: boolean; message: string }> => {
    const response = await apiClient.delete(
      `/projects/${projectId}/scheduling/${scheduleId}`
    );
    return response.data;
  },

  getLinks: async (projectId: number): Promise<GetLinksResponse> => {
    const response = await apiClient.get(`/projects/${projectId}/scheduling/links`);
    return response.data;
  },

  getLink: async (projectId: number, linkId: number): Promise<GetLinkResponse> => {
    const response = await apiClient.get(`/projects/${projectId}/scheduling/links/${linkId}`);
    return response.data;
  },

  createLink: async (
    projectId: number,
    payload: CreateLinkPayload
  ): Promise<GetLinkResponse> => {
    const response = await apiClient.post(
      `/projects/${projectId}/scheduling/links`,
      payload
    );
    return response.data;
  },

  updateLink: async (
    projectId: number,
    linkId: number,
    payload: UpdateLinkPayload
  ): Promise<GetLinkResponse> => {
    const response = await apiClient.patch(
      `/projects/${projectId}/scheduling/links/${linkId}`,
      payload
    );
    return response.data;
  },

  deleteLink: async (
    projectId: number,
    linkId: number
  ): Promise<{ status: boolean; message: string }> => {
    const response = await apiClient.delete(
      `/projects/${projectId}/scheduling/links/${linkId}`
    );
    return response.data;
  },
  createOutageWindow: async (
    projectId: string,
    payload: OutageWindowPayload[]
  ) => {
    const response = await apiClient.post(
      `projects/${projectId}/outage-windows`,
      payload
    );
    return response.data;
  },
  getOutageWindows: async (
    projectId: string | undefined
  ) => {
    const response = await apiClient.get(
      `projects/${projectId}/outage-windows`
    );
    return response.data?.data;
  },
  updateOutageWindow: async (
    projectId: string,
    outageWindowId: number,
    payload: Partial<OutageWindowPayload>
  ) => {
    const response = await apiClient.put(
      `projects/${projectId}/outage-windows/${outageWindowId}`,
      payload
    )
    return response.data;
  },
  deleteOutageWindow: async (
    projectId: string,
    outageWindowId: number
  ) => {
    const response = await apiClient.delete(
      `projects/${projectId}/outage-windows/${outageWindowId}`
    )
    return response.data;
  },
  createActivityTodo: async (
    projectId: string,
    activityId: number,
    payload: any
  ) => {
    const response = await apiClient.post(
      `projects/${projectId}/activity/${activityId}`,
      payload
    );
    return response.data;
  },
  getActivityTodos: async (
    projectId: string | undefined,
    activityId: number | undefined
  ) => {
    const response = await apiClient.get(
      `projects/${projectId}/activity/${activityId}`
    );
    return response.data;
  },
  updateActivityTodo: async (
    projectId: string,
    activityId: number,
    todoId: number,
    payload: any
  ) => {
    const response = await apiClient.put(
      `projects/${projectId}/activity/${activityId}/todo/${todoId}`,
      payload
    );
    return response
  }
};

